export const getItemCategory = (item: any) => item.category || "Other";
